import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appReports');

export const setSelectedCalendar = actionCreator<{ activePeriod: 'from' | 'to' | undefined; from: Date; to: Date }>(
  'SET_SELECTED_CALENDAR',
);
